import React, { useEffect, useMemo, useState } from "react";
import { View, Text, StyleSheet, ScrollView, Platform, Dimensions, TouchableOpacity, Keyboard } from 'react-native';
import CustomHeader from "../../customHeader/CustomHeader";
import ButtonDLSBase from "../../button/ButtonDLS.base";
import { ButtonSizeDLS, ButtonTypeDLS, ColorTokens, DividerSizeTokens, IconSizeTokens, IconTokens, InputTypeToken, SizeTypeTokens, TextAlignTokens, TypographyTypeDLS } from "@voltmoney/schema";
import Divider from "../../divider/Divider";
import TypographyDLSBase from "../../typography/TypographyDLS.base";
import { addCommasToNumber, getScreenType, isFromTDLPlatform } from "../utils";
import BottomSheet from "../BottomSheet";
import { ModalAlignmentEnum } from "@voltmoney/types";
import { isMobile, isMobileView } from "../../stack/utils";
import Icon from "../../icon/Icon";
import Space from "../../space/Space";
import TextInput from "../../textInput/TextInput";
import NeedHelpDC from "../NeedHelpDC";
import Typography from "../../typography/Typography";
const WithdrawAmount = ({ triggerAction, needHelpAction, backAction, confirmAmountAction, fetchMinAmountDetails, closeErrorModal, showInfoModal, height, availableCash = 0, loading, showErrorModal, currentModalHeight, currentErrorType, accountFee = 0, chargesDue = 0, processingFee = 0, GST = 0, stampDutyFee = 0, counter, message, withdrawalAmount, contactUsDetails, isFromJupiter, lienMarkingFee, isInProgressUnpledgingRequest }) => {
    const [inputValue, setInputValue] = useState(withdrawalAmount !== undefined && withdrawalAmount !== 0 ? `${withdrawalAmount}` : '');
    const [errorModal, setErrorModal] = useState(false);
    const [infoModal, setInfoModal] = useState(false);
    const [modalHeight, setModalHeight] = useState(288);
    const [isLoading, setLoading] = useState(false);
    const [errorType, setErrorType] = useState(currentErrorType);
    const [showNeedHelp, setShowNeedHelp] = useState(false);
    const isfromTDL = isFromTDLPlatform();
    useEffect(() => {
        setInputValue(`${withdrawalAmount}`);
    }, [withdrawalAmount]);
    useEffect(() => {
        if (showNeedHelp)
            Keyboard.dismiss();
    }, [showNeedHelp]);
    const handlePress = () => {
        const withdrawlValue = Number(inputValue);
        if (confirmAmountAction)
            triggerAction({
                ...confirmAmountAction,
                payload: {
                    withdrawlValue,
                    ...confirmAmountAction.payload
                }
            });
    };
    useEffect(() => {
        setLoading(loading);
        setErrorModal(showErrorModal);
        setModalHeight(currentModalHeight);
        setErrorType(currentErrorType);
    }, [loading, showErrorModal, currentModalHeight, counter, currentErrorType]);
    const handleModal = () => {
        setInfoModal(false);
        setErrorModal(false);
        setLoading(false);
        if (closeErrorModal)
            triggerAction(closeErrorModal);
    };
    const handleAccountFeeModal = async () => {
        const withdrawlValue = Number(inputValue);
        setInfoModal(false);
        setLoading(true);
        if (fetchMinAmountDetails)
            await triggerAction({
                ...fetchMinAmountDetails,
                payload: {
                    withdrawlValue,
                    ...fetchMinAmountDetails.payload
                }
            });
        setModalHeight(isMobileView() ? 356 : 338);
        setLoading(false);
        setErrorModal(false);
        setInfoModal(true);
    };
    const handleNeedHelp = () => {
        setShowNeedHelp(true);
    };
    const headerChild = useMemo(() => {
        return (React.createElement(CustomHeader, { goBackId: 'bt_withdrawAmount_goBack', needHelpId: 'bt_withdrawAmount_needHelp', title: 'Enter withdrawal amount', needHelpAction: handleNeedHelp, showNeedHelpNewArch: true, goBackAction: backAction, hideNeedHelp: false, triggerAction: triggerAction }));
    }, []);
    const footerChild = () => {
        return (React.createElement(ButtonDLSBase, { sizeDLS: ButtonSizeDLS.MEDIUM, loading: isLoading, typeDLS: ButtonTypeDLS.PRIMARY, label: "Proceed to confirm amount", onPress: handlePress, isDisabled: Number(inputValue) > 0 ? false : true }));
    };
    const renderErrorModal = () => {
        return (React.createElement(TouchableOpacity, { activeOpacity: 1, style: { padding: 16, zIndex: 1, alignItems: "center" } },
            React.createElement(View, { style: { marginTop: 8 } },
                React.createElement(Icon, { name: IconTokens.ErrorIcon, size: IconSizeTokens.XXXXXXL })),
            React.createElement(View, { style: { marginTop: 24 } },
                React.createElement(TypographyDLSBase, { typeDLS: TypographyTypeDLS.H4S, label: "Please enter valid amount", color: ColorTokens.Grey_Night })),
            React.createElement(View, { style: { width: '100%', marginTop: 24, backgroundColor: "#F1F3F5", padding: 12, borderRadius: 8 } },
                React.createElement(Text, { style: { flexDirection: 'row', alignItems: 'center', textAlign: 'center', marginRight: 4 } },
                    React.createElement(TypographyDLSBase, { textAlign: TextAlignTokens.center, typeDLS: TypographyTypeDLS.B1R, label: `${message} `, color: ColorTokens.Grey_Night }),
                    chargesDue !== null && chargesDue > 0 && errorType === 'AMOUNT_LESS_THAN_MINIMUM_AND_FEES' &&
                        React.createElement(TouchableOpacity, { style: { top: 2 }, hitSlop: { top: 16, left: 16, right: 16, bottom: 16 }, onPress: handleAccountFeeModal },
                            Platform.OS !== 'web' && React.createElement(View, { style: { top: 2 } },
                                React.createElement(Icon, { name: IconTokens.Info, size: IconSizeTokens.MD, color: ColorTokens.Grey_Night })),
                            Platform.OS === 'web' && React.createElement(Icon, { name: IconTokens.Info, size: IconSizeTokens.MD, color: ColorTokens.Grey_Night })))),
            React.createElement(View, { style: { width: '100%', marginTop: 24 } },
                React.createElement(ButtonDLSBase, { sizeDLS: ButtonSizeDLS.MEDIUM, loading: isLoading, typeDLS: ButtonTypeDLS.PRIMARY, label: "Ok, got it!", onPress: handleModal, isDisabled: false }))));
    };
    const renderAccountFeeModal = () => {
        return (React.createElement(TouchableOpacity, { style: { padding: 16, zIndex: 1 }, activeOpacity: 1 },
            React.createElement(TypographyDLSBase, { typeDLS: TypographyTypeDLS.H4S, label: "Account opening fee" }),
            React.createElement(Space, { size: SizeTypeTokens.XXXL }),
            React.createElement(View, { style: { padding: 8, backgroundColor: '#F1F3F5', borderRadius: 6 } },
                React.createElement(TypographyDLSBase, { typeDLS: TypographyTypeDLS.B2R, label: "This is a one-time fee. It won't apply on any future withdrawals.", textAlign: TextAlignTokens.left })),
            React.createElement(Space, { size: SizeTypeTokens.XL }),
            React.createElement(View, { style: { flexDirection: 'row', justifyContent: 'space-between' } },
                React.createElement(TypographyDLSBase, { typeDLS: TypographyTypeDLS.B1R, label: "Processing fee" }),
                React.createElement(TypographyDLSBase, { typeDLS: TypographyTypeDLS.B1R, label: `₹${addCommasToNumber(processingFee)}` })),
            React.createElement(Space, { size: SizeTypeTokens.XL }),
            React.createElement(View, { style: { flexDirection: 'row', justifyContent: 'space-between' } },
                React.createElement(TypographyDLSBase, { typeDLS: TypographyTypeDLS.B1R, label: "18% GST on processing fee" }),
                React.createElement(TypographyDLSBase, { typeDLS: TypographyTypeDLS.B1R, label: `₹${addCommasToNumber(GST)}` })),
            React.createElement(Space, { size: SizeTypeTokens.XL }),
            React.createElement(View, { style: { flexDirection: 'row', justifyContent: 'space-between' } },
                React.createElement(TypographyDLSBase, { typeDLS: TypographyTypeDLS.B1R, label: "Stamp duty fee" }),
                React.createElement(TypographyDLSBase, { typeDLS: TypographyTypeDLS.B1R, label: `₹${addCommasToNumber(stampDutyFee)}` })),
            (lienMarkingFee !== null && lienMarkingFee !== undefined) && React.createElement(View, { style: { flexDirection: 'row', justifyContent: 'space-between', marginTop: 16 } },
                React.createElement(TypographyDLSBase, { typeDLS: TypographyTypeDLS.B1R, label: "Lien marking" }),
                React.createElement(TypographyDLSBase, { typeDLS: TypographyTypeDLS.B1R, label: `₹${addCommasToNumber(lienMarkingFee)}` })),
            React.createElement(View, { style: { marginVertical: 16 } },
                React.createElement(Divider, { size: DividerSizeTokens.SM, color: ColorTokens.Grey_Chalk })),
            React.createElement(View, { style: { flexDirection: 'row', justifyContent: 'space-between' } },
                React.createElement(TypographyDLSBase, { typeDLS: TypographyTypeDLS.B1S, label: "Account opening fee" }),
                React.createElement(TypographyDLSBase, { typeDLS: TypographyTypeDLS.B1S, label: `₹${addCommasToNumber(accountFee)}` })),
            React.createElement(Space, { size: SizeTypeTokens.XXXL }),
            React.createElement(ButtonDLSBase, { sizeDLS: ButtonSizeDLS.MEDIUM, loading: isLoading, typeDLS: ButtonTypeDLS.PRIMARY, label: "Ok, got it!", onPress: handleModal, isDisabled: false })));
    };
    const modalContentPresenter = () => {
        if (errorModal)
            return renderErrorModal();
        else if (infoModal)
            return renderAccountFeeModal();
    };
    const textInputWithdraw = useMemo(() => {
        return (React.createElement(TextInput, { id: "tf_withdrawAmount_enterAmount", title: "Enter amount", type: InputTypeToken.MULTILINE, placeholder: "0", onlyNumeric: true, value: inputValue, onChangeText: (text) => {
                setInputValue(text);
            }, triggerAction: triggerAction }));
    }, [withdrawalAmount, inputValue]);
    return (React.createElement(View, { style: { height: height } },
        React.createElement(View, { style: {} }, headerChild),
        React.createElement(ScrollView, { style: { height: Platform.OS === 'ios' ? height - 88 : height - 72, paddingLeft: 16 } },
            !isfromTDL ?
                React.createElement(View, { style: { marginTop: 24, flexDirection: 'row' } },
                    React.createElement(TypographyDLSBase, { typeDLS: TypographyTypeDLS.B1R, label: "Available cash:", color: ColorTokens.Grey_Charcoal }),
                    React.createElement(View, { style: { marginLeft: 8 } },
                        React.createElement(TypographyDLSBase, { typeDLS: TypographyTypeDLS.B1S, label: '₹' + addCommasToNumber(availableCash), color: ColorTokens.Grey_Night }))) :
                React.createElement(View, { style: { marginTop: 24, marginRight: 16, backgroundColor: '#F9FAFB', borderRadius: 12, borderWidth: 1, borderColor: '#78787D3D' } },
                    React.createElement(View, { style: { flexDirection: 'row', justifyContent: 'space-between', paddingHorizontal: 16, paddingVertical: 12 } },
                        React.createElement(TypographyDLSBase, { typeDLS: TypographyTypeDLS.B1R, label: "Available cash", color: ColorTokens.Grey_Charcoal }),
                        React.createElement(TypographyDLSBase, { typeDLS: TypographyTypeDLS.B1S, label: '₹' + addCommasToNumber(availableCash), color: ColorTokens.Grey_Night }))),
            React.createElement(View, { style: { marginTop: 24, marginRight: 16 } }, textInputWithdraw),
            isInProgressUnpledgingRequest && React.createElement(View, { style: { marginTop: 32, backgroundColor: '#FDF7E7', borderColor: '#FEF4E6', borderRadius: 8, borderWidth: 1, padding: 12, marginRight: 16 } },
                React.createElement(View, { style: { flexDirection: 'row', alignItems: 'center' } },
                    React.createElement(Icon, { name: IconTokens.InfoFilled, size: IconSizeTokens.XL, color: ColorTokens.MUSTARD_YELLOW_1 }),
                    React.createElement(View, { style: { marginLeft: 8, flexShrink: 1 } },
                        React.createElement(Typography, { typeDLS: TypographyTypeDLS.B1S, label: "Un-pledge request in progress", color: ColorTokens.Grey_Night }),
                        React.createElement(View, { style: { marginTop: 2 } },
                            React.createElement(Typography, { typeDLS: TypographyTypeDLS.B2R, label: "Withdrawals may affect the approval of your ongoing un-pledge request.", color: ColorTokens.Grey_Charcoal })))))),
        React.createElement(Divider, { size: DividerSizeTokens.SM, color: ColorTokens.Grey_Chalk }),
        React.createElement(View, { style: { height: Platform.OS === 'ios' ? 88 : 72 } }),
        React.createElement(View, { style: styles.footer }, footerChild()),
        (errorModal || infoModal) && (React.createElement(View, { style: {
                position: 'absolute',
                bottom: Platform.OS == 'ios' ? 16 : 0,
            } },
            React.createElement(BottomSheet, { autoAdjustHeight: false, height: modalHeight, width: '100%', closeFunction: handleModal, alignment: ModalAlignmentEnum.BOTTOM, backgroundColor: 'transparent', hasDraggableIcon: false, sheetBackgroundColor: 'white', isDismissible: true, radius: 4, screenHeight: isMobile(getScreenType(Dimensions.get('window').width)) ? Dimensions.get('window').height + 10 : height, screenWidth: isMobile(getScreenType(Dimensions.get('window').width)) ? Dimensions.get('window').width : 508, routeId: "routeId", handleKeyboard: true }, modalContentPresenter()))),
        showNeedHelp && React.createElement(NeedHelpDC, { showNeedHelp: showNeedHelp, setShowNeedHelp: setShowNeedHelp, contactUsDetails: contactUsDetails, isFromJupiter: isFromJupiter })));
};
const styles = StyleSheet.create({
    header: {
        position: 'absolute',
        top: 0,
        zIndex: 1,
        width: '100%',
    },
    footer: {
        position: 'absolute',
        bottom: Platform.OS === 'ios' ? 16 : 0,
        zIndex: 0,
        width: '100%',
        padding: 16,
    },
    modalContainer: {
        alignItems: "center",
        padding: 16,
        // flex: 1,
        zIndex: 1
    },
});
export default WithdrawAmount;
